const DpoCoreZadostZmenaStavu = {
    tlacitka: [
        "tlacitkoPodat",
        "tlacitkoDopracovat",
        "tlacitkoPodkladyDoplneny",
        "tlacitkoVyuctovaniVlozeno"
    ],

    stavZadostiEvent: function () {
        const elementStavZadosti = $("#modal-stavzadosti");
        if (elementStavZadosti.length) {
            elementStavZadosti
                .off("change")
                .on("change", function () {
                    DpoCoreZadostZmenaStavu.aktualizaceFormulare(false);
                });
        }
    },

    initZmenaStavuZadostiAdministratorem: function () {
        const tlacitko = $("#tlacitkoZmenaStavuZadosti");
        if (!tlacitko.length) {
            return;
        }

        $(document)
            .on("modal.button.miniform.build", function (e, data) {
                if (true !== data.hasOwnProperty("miniformId")
                    || 107 !== parseInt(data["miniformId"])
                ) {
                    return;
                }

                DpoCoreZadostZmenaStavu.stavZadostiEvent();

                $(document)
                    .on("modal.button.miniform.error", function (e, data) {
                        if (true !== data.hasOwnProperty("miniformId")
                            || 107 !== parseInt(data["miniformId"])
                        ) {
                            return;
                        }
                        DpoCoreZadostZmenaStavu.aktualizaceFormulare(true);
                        DpoCoreZadostZmenaStavu.stavZadostiEvent();
                    });
            });

        $(document)
            .on("modal.button.miniform.close.pre", function (e, data) {
                if (true !== data.hasOwnProperty("miniformId")
                    || 107 !== parseInt(data["miniformId"])
                ) {
                    return;
                }

                const tlacitkoSubmit = $(":button[name=\"saveContinue\"]");
                if (!tlacitkoSubmit.length) {
                    return;
                }

                const form = $(tlacitkoSubmit.parents("form"));
                if (!form.length) {
                    return;
                }

                const modalForm = $("#miniform");
                if (!modalForm.length) {
                    return;
                }

                const elementStavZadosti = $("#modal-stavzadosti");
                if (!elementStavZadosti.length) {
                    return;
                }

                const elementOdeslatEmail = $("#modal-odeslatemail");
                if (!elementOdeslatEmail.length) {
                    return;
                }
                let odeslatEmail = "0";
                if (true === elementOdeslatEmail.prop("checked")) {
                    odeslatEmail = "1";
                }

                const elementKomentar = $("#modal-komentar");
                if (!elementKomentar.length) {
                    return;
                }

                $('<input/>', {
                    "type": "hidden",
                    "name": "zmenaStavuZadostiStavId",
                    "value": elementStavZadosti.val()
                }).appendTo($(form));

                $('<input/>', {
                    "type": "hidden",
                    "name": "zmenaStavuZadostiOdeslatEmail",
                    "value": odeslatEmail
                }).appendTo($(form));

                $('<input/>', {
                    "type": "hidden",
                    "name": "zmenaStavuZadostiKomentar",
                    "value": elementKomentar.val()
                }).appendTo($(form));

                $('<input/>', {
                    "type": "hidden",
                    "name": "saveContinue"
                }).appendTo($(form));

                const stavId = parseInt(elementStavZadosti.val());

                if (24 === stavId) {
                    let text = '<p class="text text-center font-weight-bold">';
                    text += "Opravdu chcete přejít na stav ÚPK/Kontrola?";
                    text += "</p>";
                    text += '<div class="text-center">';
                    text += '<i class="fa fa-exclamation-triangle fa-fw fa-5x mt-3 mb-4 text-danger"></i>';
                    text += "</div>";
                    text += "<p class='text text-center'>";
                    text += "Tento stav nastává až po ukončení Kontroly. Z tohoto stavu již nelze žadatele znovu vyzvat k doplnění podkladů/vyúčtování.";
                    text += "</p>";

                    Lemo_Modal.setTitle('ÚPK / Kontrola');
                    Lemo_Modal.setContent(text);
                    Lemo_Modal.addButton('continue', '<i class="fas fa-fw fa-check"></i> Pokračovat', 'btn btn-primary', function() {
                        DpoCoreZadostZmenaStavu.odeslatZadost("zmenaStavuAdministratorem");
                        Lemo_Modal.close();
                    });
                    Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> Zrušit', 'btn btn-secondary', function() {
                        Lemo_Alert.addInfo("Změna stavu žádosti byla zrušena.");
                        Lemo_Modal.close();
                    });
                    Lemo_Modal.build(null);
                } else {
                    DpoCoreZadostZmenaStavu.odeslatZadost("zmenaStavuAdministratorem");
                }
            });
    },

    aktualizaceFormulare: function (chyba) {
        "use strict";
        const elementStavZadosti = $("#modal-stavzadosti");
        if (!elementStavZadosti.length) {
            return;
        }
        const stavId = parseInt(elementStavZadosti.val());

        const formGroup = $("#form-group-modal-komentar");
        if (formGroup.length) {
            let em = formGroup.find("em.required");
            if (!em.length) {
                let label = formGroup.find("label");
                label.append("&nbsp;<em class=\"required d-none\">*</em>");
                em = formGroup.find("em.required");
            }

            if (true === DpoCoreZadostZmenaStavu.povinnyKomentar(stavId)) {
                em.removeClass("d-none");
            } else {
                em.addClass("d-none");
            }

            if (false === chyba) {
                formGroup.find(".is-invalid").removeClass("is-invalid");
                formGroup.find(".invalid-feedback").remove();
            }
        }

        const elementOdeslatEmail = $("#modal-odeslatemail");
        if (elementOdeslatEmail.length) {
            if (true === DpoCoreZadostZmenaStavu.odeslatEmail(stavId)) {
                elementOdeslatEmail.attr("checked", true).prop("checked", true);
                elementOdeslatEmail.attr("disabled", true).prop("disabled", true);
            } else {
                elementOdeslatEmail.attr("checked", false).prop("checked", false);
                elementOdeslatEmail.attr("disabled", false).prop("disabled", false);
            }
        }
    },

    povinnyKomentar: function (stavId) {
        "use strict";
        let result = false;
        if (!stavId) {
            return result;
        }

        const elementStavZadosti = $("#modal-stavzadosti");
        if (!elementStavZadosti.length) {
            return result;
        }

        const data = elementStavZadosti.data("povinny-komentar");
        if (typeof data === "undefined" || !data.length) {
            return result;
        }

        $.each(data.split("|"), function (i, st) {
            if (parseInt(stavId) === parseInt(st)) {
                result = true;
                return false;
            }
        });

        return result;
    },

    odeslatEmail: function (stavId) {
        "use strict";
        let result = false;
        if (!stavId) {
            return result;
        }

        const elementStavZadosti = $("#modal-stavzadosti");
        if (!elementStavZadosti.length) {
            return result;
        }

        const data = elementStavZadosti.data("odeslat-email");
        if (typeof data === "undefined" || !data.length) {
            return result;
        }

        $.each(data.split("|"), function (i, st) {
            if (parseInt(stavId) === parseInt(st)) {
                result = true;
                return false;
            }
        });

        return result;
    },

    initZmenaStavuZadostiZadatelem: function () {
        $.each(DpoCoreZadostZmenaStavu.tlacitka, function (i, name) {
            const tlacitko = $("#" + name);
            if (tlacitko.length) {
                tlacitko
                    .off("click")
                    .on("click", function (e) {
                        e.preventDefault();
                        if ($(this).hasClass("disabled")) {
                            return;
                        }
                        DpoCoreZadostZmenaStavu.odeslatZadost(name);
                    });
            }
        });
    },

    odeslatZadost: function (name) {
        const tlacitkoSubmit = $(":button[name=\"saveContinue\"]");
        if (tlacitkoSubmit.length) {
            tlacitkoSubmit
                .attr("name", name)
                .trigger("click");
        }
    }
};

$(document).ready(function () {
    DpoCoreZadostZmenaStavu.initZmenaStavuZadostiAdministratorem();
    DpoCoreZadostZmenaStavu.initZmenaStavuZadostiZadatelem();
});